import barba from '@barba/core';
import MicroModal from 'micromodal';

export default class {

    constructor() {

        barba.hooks.afterOnce((data) => {
            this.init()
        });
        barba.hooks.leave((data) => {
            this.init.kill()
        });
        barba.hooks.afterEnter((data) => {
            this.init()
        });
    }

    init() {

        const attach = (t) => {
            const id = t.getAttribute("data-modal-trigger");
            t.addEventListener('click', (e) => {
                e.preventDefault();

                // Ensure the video source is set before showing the modal
                const modal = document.getElementById(id);
                const video = modal.querySelector('video');
                if (video) {
                    const currentPlayingVideo = document.querySelector(".js-hero__mov__item[style*='block'] video");
                    if (currentPlayingVideo && currentPlayingVideo.src) {
                        video.src = currentPlayingVideo.src;
                        video.load();
                    }
                }

                MicroModal.show(id, {
                    openClass: 'is-open',
                    disableFocus: false,
                    disableScroll: true,
                    awaitOpenAnimation: true,
                    awaitCloseAnimation: true,
                    onShow: (modal) => {
                        const video = modal.querySelector('video');
                        if (video && video.src) {
                            video.play().catch(error => {
                                //console.error('Error playing video:', error);
                            });
                        } else {
                            //console.warn('No valid video source found.');
                        }
                    },
                    onClose: (modal) => {
                        const video = modal.querySelector('video');
                        if (video) {
                            video.pause();
                            video.currentTime = 0; // 動画をリセットする
                        }
                    }
                });
            });
        }

        const modalTrigger = document.querySelectorAll("[data-modal-trigger]");
        if (modalTrigger.length > 0) {
            modalTrigger.forEach(t => {
                attach(t);
            });
        }
    }
}


// import barba from '@barba/core';
// import MicroModal from 'micromodal';

// export default class{

// 	constructor(){

//         barba.hooks.afterOnce((data) => {
//             this.init()
//         });
//         barba.hooks.leave((data) => {
//             this.init.kill()
//         });
//         barba.hooks.afterEnter((data) => {
//             this.init()
//         });
//     }
//     init (){

//         // MicroModal.show({
//         //     openClass: 'is-open',
//         //     disableFocus: false,
//         //     awaitOpenAnimation: false,
//         //     awaitCloseAnimation: false,
//         //     debugMode: true
//         // });
//         const attatch = (t) => {
//             const id = t.getAttribute("data-modal-trigger")
//             t.addEventListener('click',(e)=>{
//                 e.preventDefault()
//                 MicroModal.show(id,
//                     {
//                         openClass: 'is-open',
//                         disableFocus: false,
//                         disableScroll: true,
//                         awaitOpenAnimation: true,
//                         awaitCloseAnimation: true
//                     }
//                 )
//             })
//         }
//         const modalTrigger = document.querySelectorAll("[data-modal-trigger]")
//         if(modalTrigger.length > 0){
//             modalTrigger.forEach(t => {
//                 attatch(t)
//             })
//         }
//     }
// }